/* ==========================================================
   Image Gallery — behavior
   Just the stagger-in scroll animation, using the same
   dependency-free approach as the theme's other custom sections
   (Product Showcase, Harvest Wellness, Feature Highlights): no
   external library, no CDN request. Content is always visible by
   default (see image-gallery.css) — this only ever ADDS a subtle
   motion on top when it can, once per page load, the first time
   each group reaches the viewport.
   ========================================================== */

(function () {
  "use strict";

  var CONTENT_STAGGER = 0.12;
  var GROUP_DELAY = 0.12;

  function init(root) {
    initStagger(root);
  }

  function initStagger(root) {
    if (root.dataset.stagger === "false") return;
    if (typeof IntersectionObserver === "undefined") return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var groupEls = Array.prototype.slice.call(root.querySelectorAll("[data-stagger-group]"));
    groupEls.forEach(function (groupEl, order) {
      var items = Array.prototype.slice.call(groupEl.querySelectorAll("[data-stagger-item]"));
      if (!items.length) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            playGroup(items, order);
          });
        },
        { threshold: 0 }
      );
      observer.observe(groupEl);
    });
  }

  function playGroup(items, order) {
    var groupDelay = order * GROUP_DELAY;

    items.forEach(function (item, i) {
      item.classList.add("stagger-pre");
      item.style.transitionDelay = (groupDelay + i * CONTENT_STAGGER) + "s";
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        items.forEach(function (item) {
          item.classList.remove("stagger-pre");
          item.classList.add("stagger-in");
        });
      });
    });
  }

  document.querySelectorAll("[data-image-gallery]").forEach(init);
})();